function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  ).filter(element => {
    // Filter out hidden elements
    return element.offsetWidth > 0 && 
           element.offsetHeight > 0 && 
           !element.classList.contains('hidden') &&
           window.getComputedStyle(element).display !== 'none' &&
           window.getComputedStyle(element).visibility !== 'hidden';
  });
}

class SectionId {
  static #separator = '__';

  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (!container.contains(event.target)) {
      const elements = getFocusableElements(container);
      const first = elements[0] || container;
      first.focus();
    }
  };

  trapFocusHandlers.focusout = function () {
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return;

    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    if (!first || !last) return;

    const isOutsideContainer = !container.contains(document.activeElement);

    if ((document.activeElement === last || isOutsideContainer) && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if ((document.activeElement === container || document.activeElement === first || isOutsideContainer) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  document.addEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) {
    elementToFocus.focus();
    if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  }

}

try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube, iframe[src*="youtube.com"], iframe[src*="youtu.be"]').forEach((video) => {
    try {
      if (video.contentWindow) {
        video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      }
    } catch (e) {
    }
  });
  
  document.querySelectorAll('.js-vimeo, iframe[src*="vimeo.com"]').forEach((video) => {
    try {
      if (video.contentWindow) {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      }
    } catch (e) {
    }
  });
  
  document.querySelectorAll('video').forEach((video) => {
    if (!video.paused) {
      video.pause();
    }
  });
  
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) {
      model.modelViewerUI.pause();
    }
    const modelViewer = model.querySelector('model-viewer');
    if (modelViewer && modelViewer.pause) {
      modelViewer.pause();
    }
  });
  
  document.querySelectorAll('model-viewer').forEach((modelViewer) => {
    if (modelViewer.pause) {
      modelViewer.pause();
    }
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {

  constructor() {
    super();
  
    this.mainDetailsToggle = this.querySelector('details');
  
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);
    this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
  
    this.addEventListener('keyup', this.onKeyUp);
    this.addEventListener('focusout', this.onFocusOut);
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) => {
      summary.removeEventListener('click', this.onSummaryClick);
      summary.addEventListener('click', this.onSummaryClick);
    });
  
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button):not(.toggle-color-mode)'
    ).forEach((button) => {
      button.removeEventListener('click', this.onCloseButtonClick);
      button.addEventListener('click', this.onCloseButtonClick);
    });
  }
  

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  
    const focusFirstInSubmenu = () => {
      const submenu = summaryElement.nextElementSibling;
      if (!submenu) return;
  
      const focusable = submenu.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
  
      if (focusable) {
        focusable.focus();
      }
  
      submenu.removeEventListener('transitionend', focusFirstInSubmenu);
    };
  
    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
  
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
  
      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        if (parentMenuElement) parentMenuElement.classList.add('submenu-open');
  
        if (!reducedMotion || reducedMotion.matches) {
          focusFirstInSubmenu();
        } else {
          const submenu = summaryElement.nextElementSibling;
          if (submenu) {
            submenu.addEventListener('transitionend', focusFirstInSubmenu);
          }
        }
      }, 100);
    }
  }
  

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
  
    summaryElement.setAttribute('aria-expanded', true);
  
    if (typeof trapFocus === 'function') {
      trapFocus(this.mainDetailsToggle, summaryElement);
    }
  
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');

    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      if (!details.classList.contains('mobile-facets__details')) {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      }
    });

    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });

    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);

    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    if (parentMenuElement) {
      parentMenuElement.classList.remove('submenu-open');
    }
  
    detailsElement.classList.remove('menu-opening');
    const summary = detailsElement.querySelector('summary');
    if (summary) {
      summary.setAttribute('aria-expanded', false);
    }
  
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;
  
    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }
  
      const elapsedTime = time - animationStart;
  
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
      }
    };
  
    window.requestAnimationFrame(handleAnimation);
  }
  
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.onDocumentPointerDown = this.onDocumentPointerDown.bind(this);
  }

  onDocumentClick(event) {
    if (!this.mainDetailsToggle.hasAttribute('open')) return;
    if (event.target.closest('.menu-drawer')) return;
    if (this.mainDetailsToggle.contains(event.target)) return;

    const searchRoot = event.target.closest('.header__search');
    const searchInput = searchRoot?.querySelector('input[type="search"]');
    const isSearchIconToggle = event.target.closest('summary.header__icon--search');

    if (searchInput && !isSearchIconToggle) {
      this.closeMenuDrawer(new MouseEvent('click'), searchInput);
      return;
    }

    if (isSearchIconToggle) {
      this.closeMenuDrawer(new MouseEvent('click'), null);
      return;
    }

    const summary = this.mainDetailsToggle.querySelector('summary');
    this.closeMenuDrawer(new MouseEvent('click'), summary);
  }

  onDocumentPointerDown(event) {
    if (!this.mainDetailsToggle.hasAttribute('open')) return;
    if (event.target.closest('.menu-drawer')) return;
    if (this.mainDetailsToggle.contains(event.target)) return;

    const searchRoot = event.target.closest('.header__search');
    const searchInput = searchRoot?.querySelector('input[type="search"]');
    const isSearchIconToggle = event.target.closest('summary.header__icon--search');

    if (!searchInput || isSearchIconToggle) return;

    this.closeMenuDrawer(new MouseEvent('click'), searchInput);
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.mainDetailsToggle.hasAttribute('open')) return;
      if (this.querySelector('.menu-drawer')?.contains(document.activeElement)) return;
      if (this.mainDetailsToggle.contains(document.activeElement)) return;
    });
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.addEventListener('pointerdown', this.onDocumentPointerDown, true);
    document.addEventListener('click', this.onDocumentClick, true);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!this.mainDetailsToggle.hasAttribute('open')) return;

    const focusTarget =
      arguments.length > 1 ? elementToFocus : this.mainDetailsToggle.querySelector('summary');

    document.removeEventListener('pointerdown', this.onDocumentPointerDown, true);
    document.removeEventListener('click', this.onDocumentClick, true);
    super.closeMenuDrawer(event || new MouseEvent('click'), focusTarget);
    this.header = this.header || document.querySelector('.section-header .header-wrapper');
    this.header?.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  static inheritedStyleCache = new Map();

  constructor() {
    super();
  }

  parseQuickOrderListHtml(responseText) {
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    return html.querySelector('.quick-order-list-container') ? html : null;
  }

  fetchQuickOrderListSection(productUrl, sectionId) {
    const url = new URL(productUrl, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    return fetch(`${url.pathname}${url.search}`)
      .then((response) => (response.ok ? response.text() : Promise.resolve('')))
      .then((responseText) => (responseText ? this.parseQuickOrderListHtml(responseText) : null));
  }

  getInheritedStylesFromProduct(productUrl, templateKey) {
    const cacheKey = templateKey || productUrl;
    if (BulkModal.inheritedStyleCache.has(cacheKey)) {
      return BulkModal.inheritedStyleCache.get(cacheKey);
    }

    const promise = fetch(productUrl)
      .then((response) => (response.ok ? response.text() : ''))
      .then((responseText) => {
        if (!responseText) return null;
        return this.extractQuickOrderListStyles(this.parseQuickOrderListHtml(responseText));
      })
      .catch(() => null);

    BulkModal.inheritedStyleCache.set(cacheKey, promise);
    return promise;
  }

  extractQuickOrderListStyles(html) {
    const quickOrderList = html?.querySelector('quick-order-list');
    if (!quickOrderList) return null;

    return {
      label_style: quickOrderList.dataset.labelStyle,
      view_cart_button_style: quickOrderList.dataset.viewCartButtonStyle,
      remove_all_button_style: quickOrderList.dataset.removeAllButtonStyle,
    };
  }

  applyQuickOrderListStyles(root, styles) {
    if (!root || !styles) return;

    const buttonKinds = ['primary', 'secondary', 'outline', 'link'];
    const setButtonStyle = (element, style) => {
      if (!element || !style) return;
      buttonKinds.forEach((kind) => element.classList.remove(`button--${kind}`));
      element.classList.add(`button--${style}`);
    };

    root.querySelectorAll('.quick-order-list__table thead th').forEach((heading) => {
      heading.classList.toggle('quick-order-list__label--normal', styles.label_style === 'normal');
    });

    root.querySelectorAll('.quick-order-list__button, .quick-order-list__button-confirm').forEach((button) => {
      setButtonStyle(button, styles.view_cart_button_style);
    });

    root.querySelectorAll(
      'quick-order-list-remove-all-button[data-action="confirm"] button, .quick-order-list__button-cancel'
    ).forEach((button) => {
      setButtonStyle(button, styles.remove_all_button_style);
    });
  }

  persistInheritedStyles(styles) {
    if (!styles) return;
    if (styles.label_style) this.dataset.inheritedLabelStyle = styles.label_style;
    if (styles.view_cart_button_style) this.dataset.inheritedViewCartButtonStyle = styles.view_cart_button_style;
    if (styles.remove_all_button_style) this.dataset.inheritedRemoveAllButtonStyle = styles.remove_all_button_style;
  }

  getInheritedStyles() {
    if (!this.dataset.inheritedViewCartButtonStyle && !this.dataset.inheritedLabelStyle) return null;

    return {
      label_style: this.dataset.inheritedLabelStyle,
      view_cart_button_style: this.dataset.inheritedViewCartButtonStyle,
      remove_all_button_style: this.dataset.inheritedRemoveAllButtonStyle,
    };
  }

  prepareQuickOrderListForModal(html) {
    const container = html.querySelector('.quick-order-list-container');
    if (!container) return '';

    const quickOrderList = container.querySelector('quick-order-list');
    if (quickOrderList) {
      quickOrderList.classList.remove('page-width');
      Array.from(quickOrderList.classList).forEach((className) => {
        if (className.startsWith('section-') && className.endsWith('-padding')) {
          quickOrderList.classList.remove(className);
        }
      });
      quickOrderList.classList.add('section-bulk-quick-order-list-padding');
    }

    return container.parentNode.innerHTML;
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        const qolTemplate = this.dataset.qolTemplate;
        const inheritedStylesPromise = qolTemplate
          ? this.getInheritedStylesFromProduct(productUrl, qolTemplate)
          : Promise.resolve(null);

        Promise.all([
          this.fetchQuickOrderListSection(productUrl, 'bulk-quick-order-list'),
          inheritedStylesPromise,
        ])
          .then(([html, styles]) => {
            if (!html) return;

            this.innerHTML = this.prepareQuickOrderListForModal(html);
            this.persistInheritedStyles(styles);
            this.applyQuickOrderListStyles(this, styles);

            const modal = this.closest('modal-dialog');
            if (modal && modal.hasAttribute('open')) {
              const dialogElement = modal.querySelector('[role="dialog"]');
              if (dialogElement) {
                trapFocus(modal, dialogElement);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class CardVariants extends HTMLElement {
  constructor() {
    super();
		this.disableClass = 'card-variant--disabled';
		this.currentId = null;
		this.productCard = null;
		this.quickAdd = null;
		this.price = null;
		this.cardColorSwatches = null;
  }
}

CardVariants.prototype.connectedCallback = function () {
  this.setupElements();
  this.addEventListeners();
  this.addActiveState();
};

CardVariants.prototype.setupElements = function () {
  this.productCard = this.closest('[data-component="card-wrapper"]');
  if (!this.productCard) return;

  this.quickAdd = this.productCard.querySelectorAll('.quick-add__submit');
  this.price = this.productCard.querySelector('[data-component="price"]');
  this.cardColorSwatches = this.querySelectorAll('[data-component="card-variant"]');
  this.currentId =  null;
};

CardVariants.prototype.addEventListeners = function () {
  if (!this.cardColorSwatches?.length) return;

  this.cardColorSwatches.forEach((swatch) => {
    ['click', 'keydown'].forEach(eventType => {
      swatch.addEventListener(eventType, (event) => this.handleSwatchInteraction(event, swatch));
    });
  });
};

CardVariants.prototype.handleSwatchInteraction = function (event, swatch) {
  if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
  event.preventDefault();
  
  const variantId = swatch.dataset.variantId;
  if (!variantId || this.currentId === variantId) return;
  
  this.currentId = variantId;
  const isDisabled = swatch.classList.contains(this.disableClass);
  
  this.toggleAddButton(isDisabled, window.variantStrings.soldOut);
  this.toggleSoldOutBadge(isDisabled);
  this.updateVariantInput(variantId);
  this.toggleQuickAddId();
  this.updatePrice(variantId);
  this.updateSwatchState(swatch);
  this.updateProductImages(swatch);
};

CardVariants.prototype.updateSwatchState = function (activeSwatch) {
  this.cardColorSwatches.forEach(swatch => swatch.classList.remove('active'));
  activeSwatch.classList.add('active');
};

CardVariants.prototype.updateProductImages = function (swatch) {
  const variantImage = swatch.dataset.variantImg;
  if (!variantImage) return;
  
  this.productCard.querySelectorAll('[data-component="card-image"]').forEach(image => {
    image.src = variantImage;
    image.srcset = variantImage;
  });
};

CardVariants.prototype.toggleAddButton = function (disable = true, text) {
  const addButton = this.productCard?.querySelector('[data-component="add-to-cart-btn"]');
	
  const addButtonText = addButton?.querySelector('.text-span') || addButton?.querySelector('span');
  if (!addButton) return;

  const preorder = this.productCard?.dataset?.preorder === 'true' && window.variantStrings?.preOrder;
  if (disable && preorder) {
    disable = false;
  }

  addButton.toggleAttribute('disabled', disable);
  if (!addButtonText) return;
  if (disable) {
    if (text) addButtonText.textContent = text;
  } else {
    addButtonText.textContent = preorder ? window.variantStrings.preOrder : window.variantStrings.addToCart;
  }
};

CardVariants.prototype.toggleSoldOutBadge = function (isDisabled) {
  if (!this.productCard) return;

  const badgeContainer = this.productCard.querySelector('.card__badge.top.left');
  if (!badgeContainer) return;

  const soldOutBadge = badgeContainer.querySelector('.badge-sold-out');
  if (soldOutBadge) {
    const preorder = this.productCard.dataset?.preorder === 'true';
    soldOutBadge.style.display = isDisabled && !preorder ? '' : 'none';
  }
};

CardVariants.prototype.toggleQuickAddId = function () {
  this.quickAdd?.forEach(btn => btn.dataset.productId = this.currentId);
};

CardVariants.prototype.updateVariantInput = function (id) {
  const input = this.productCard?.querySelector('input[name="id"]');
  if (!input) return;
  input.value = id;
  input.dispatchEvent(new Event('change', { bubbles: true }));
};

CardVariants.prototype.updatePrice = function (id) {
  const selectedSwatch = this.querySelector(`[data-variant-id="${id}"]`);
  if (!selectedSwatch || !this.price) return;

  const { variantPrice, variantComparePrice, variantCurrency } = selectedSwatch.dataset;
  const currency_code = variantCurrency ? ` ${variantCurrency}` : '';

  function cleanPriceToCents(priceStr) {
    if (typeof priceStr !== 'string') return NaN;
    return parseInt(priceStr.replace(/\D/g, ''), 10);
  }

  const price = cleanPriceToCents(variantPrice);
  const comparePrice = cleanPriceToCents(variantComparePrice);

  const showCompare = !isNaN(comparePrice) && comparePrice > price;

  const priceHTML = showCompare
    ? `<div class="price__sale">
        <span class="price-item price-item--sale price-item--last">${window.cartStrings.currency}${variantPrice}${currency_code}</span>
        <span class="compare-price"><s class="price-item price-item--regular">${window.cartStrings.currency}${variantComparePrice}${currency_code}</s></span>
      </div>`
    : `${window.cartStrings.currency}${variantPrice}${currency_code}`;

  this.price.classList.toggle('price--on-sale', showCompare);
  this.price.innerHTML = priceHTML;
  this.updateDiscountBadge(price, comparePrice, showCompare);
};

CardVariants.prototype.updateDiscountBadge = function (price, comparePrice, showCompare) {
  if (!this.productCard) return;

  const badgeContainer = this.productCard.querySelector('.card__badge.top.left');
  if (!badgeContainer) return;

  const discountBadge = badgeContainer.querySelector('.badge-percents');
  const textBadges = badgeContainer.querySelectorAll('.badge:not(.badge-percents):not(.badge-sold-out)');
  const scrollingSaleBadge = this.productCard.querySelector('.card__badge-scroll.sale-scroll');

  if (!showCompare || !Number.isFinite(price) || !Number.isFinite(comparePrice) || comparePrice <= 0) {
    if (discountBadge) discountBadge.style.display = 'none';
    textBadges.forEach((badge) => {
      badge.style.display = 'none';
    });
    if (scrollingSaleBadge) scrollingSaleBadge.style.display = 'none';
    return;
  }

  const savingsPercent = Math.round(((comparePrice - price) * 100) / comparePrice);
  if (discountBadge) {
    discountBadge.textContent = `- ${savingsPercent}%`;
    discountBadge.style.display = '';
  }
  textBadges.forEach((badge) => {
    badge.style.display = '';
  });
  if (scrollingSaleBadge) scrollingSaleBadge.style.display = '';
};

CardVariants.prototype.addActiveState = function () {
  if (!this.cardColorSwatches?.length) return;
  this.cardColorSwatches.forEach((swatch) => {
    if (!swatch.dataset.variantImg || !this.productCard) return;

    const productImages = this.productCard.querySelectorAll('[data-component="card-image"]');
    if (!productImages.length) return;

    if (productImages[0].src.includes(swatch.dataset.variantImg)) {
      swatch.classList.add('active');
    }
  });
	this.cardColorSwatches[0]?.click()
};

CardVariants.prototype.disableCurrentVariant = function () {
	
	const activeVariant = this.querySelector('.active');
	if (!activeVariant) return;

	activeVariant.classList.add(this.disableClass)
}

if (!customElements.get('card-variants')) {
  customElements.define('card-variants', CardVariants);
}

class DeferredMedia extends HTMLElement {
  constructor() {
    super();

    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;

    poster.addEventListener('click', () => this.loadContent(true));
  }

  pauseIframe(iframe) {
    try {
      const src = iframe.src || '';
      if (!src) return;

      if (
        src.includes('youtube.com') ||
        src.includes('youtu.be') ||
        src.includes('youtube-nocookie.com')
      ) {
        iframe.contentWindow?.postMessage(
          JSON.stringify({
            event: 'command',
            func: 'pauseVideo',
            args: ''
          }),
          '*'
        );
      } else if (src.includes('vimeo.com')) {
        iframe.contentWindow?.postMessage('{"method":"pause"}', '*');
      }
    } catch (e) {
      console.log('pauseIframe error', e);
    }
  }

  pauseAllMediaExcept(currentMedia = null) {
    const elements = document.querySelectorAll('video, iframe, model-viewer, product-model');

    elements.forEach((el) => {
      if (currentMedia && el === currentMedia) return;

      if (el.tagName === 'VIDEO') {
        if (!el.paused) {
          el.pause();
        }
        return;
      }

      if (el.tagName === 'IFRAME') {
        this.pauseIframe(el);
        return;
      }

      if (el.matches('model-viewer, product-model')) {
        if (el.tagName === 'PRODUCT-MODEL' && el.modelViewerUI) {
          el.modelViewerUI.pause();
        } else if (typeof el.pause === 'function') {
          el.pause();
        }
      }
    });
  }

  pauseSiblingsMedia(currentMedia = null, fromPlayEvent = false) {
    if (!fromPlayEvent && typeof window.pauseAllMedia === 'function') {
      window.pauseAllMedia();
    }

    this.pauseAllMediaExcept(currentMedia);
  }

  attachMediaListeners(media) {
    if (media.nodeName === 'VIDEO') {
      media.addEventListener('play', () => {
        this.pauseSiblingsMedia(media, true);
      });
    }
  }

  loadContent(focus = true) {
    let deferredElement;

    if (!this.hasAttribute('loaded')) {
      const template = this.querySelector('template');
      if (!template) return;

      const wrapper = document.createElement('div');
      wrapper.appendChild(template.content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', 'true');

      deferredElement = wrapper.querySelector('video, model-viewer, iframe');
      if (!deferredElement) return;

      this.appendChild(deferredElement);

      this.attachMediaListeners(deferredElement);

      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        if (formerStyle == null) {
          deferredElement.removeAttribute('style');
        } else {
          deferredElement.setAttribute('style', formerStyle);
        }
      }, 0);
    } else {
      deferredElement = this.querySelector('video, model-viewer, iframe');
      if (!deferredElement) return;
    }

    this.pauseSiblingsMedia(deferredElement, false);

    if (focus && typeof deferredElement.focus === 'function') {
      deferredElement.focus();
    }

    if (
      deferredElement.nodeName === 'VIDEO' &&
      deferredElement.getAttribute('autoplay')
    ) {
      deferredElement.play();
    }
  }
}

if (!customElements.get('deferred-media')) {
  customElements.define('deferred-media', DeferredMedia);
}


class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');

    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  // In RTL, scrollLeft runs negative and offsetLeft still measures from the
  // container's physical left edge regardless of dir -- these three keep every
  // scrollLeft/offsetLeft read and write in this class expressed as "distance
  // from the reading-start edge" instead, so the LTR branch (isRtl false) is
  // always a no-op and RTL gets the mirrored equivalent.
  get isRtl() {
    return document.documentElement.getAttribute('dir') === 'rtl';
  }

  scrollStart() {
    return this.isRtl ? Math.abs(this.slider.scrollLeft) : this.slider.scrollLeft;
  }

  offsetStart(element) {
    return this.isRtl
      ? this.slider.scrollWidth - element.offsetWidth - element.offsetLeft
      : element.offsetLeft;
  }

  scrollToStart(position) {
    this.slider.scrollTo({
      left: this.isRtl ? -position : position,
    });
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = Math.abs(this.offsetStart(this.sliderItemsToShow[1]) - this.offsetStart(this.sliderItemsToShow[0]));
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.offsetStart(this.sliderItemsToShow[0])) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.scrollStart() / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollStart() === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.scrollStart() - offset;
    return this.offsetStart(element) + element.clientWidth <= lastVisibleSlide && this.offsetStart(element) >= this.scrollStart();
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.scrollStart() + step * this.sliderItemOffset
        : this.scrollStart() - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.scrollToStart(position);
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));

    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
            this.announcementBarArrowButtonWasClicked = true;
          }, 
          { 
            once: true 
          }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.scrollStart() + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);
    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.scrollToStart(position);
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    if (this.sliderControlButtons) {
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', 'true');
    }
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.scrollStart() + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.scrollStart() + this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.scrollToStart(slideScrollPosition);
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VerticalSlideshowComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = true;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');

    // Determine button structure
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));

    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();

  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientHeight > 0);
    if (this.sliderItemsToShow.length < 2) return;

    this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
    this.slidesPerPage = Math.floor(
      (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset
    );

    this.totalPages = Math.ceil(this.sliderItemsToShow.length / this.slidesPerPage);
    this.update();
  }

  update() {
    if (!this.slider || !this.nextButton) return;
  
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
  
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
  
    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1],
        },
      }));
    }

    this.updateButtonState();
    this.updatePagination();
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    const direction = event.currentTarget.name === 'next' ? 1 : -1;
    this.slideScrollPosition = this.slider.scrollTop + direction * step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      top: position,
      behavior: 'smooth',
    });
  }

  updatePagination() {
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    if (!this.sliderControlButtons.length) return;


    this.sliderControlButtons.forEach((link, index) => {
      link.dataset.index = index + 1;
      link.addEventListener('click', (event) => {
        const index = event.currentTarget.dataset.index;
        this.setSlidePosition((index - 1) * this.sliderItemOffset);
      });
    });

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', 'true');

  }
  
  updateButtonState() {
    const isFirstSlideVisible = this.currentPage === 1;
    const isLastSlideVisible = this.currentPage === this.totalPages;

    this.prevButton.disabled = isFirstSlideVisible;
    this.nextButton.disabled = isLastSlideVisible;
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.autoplay = setInterval(() => this.autoRotateSlides(), this.autoplaySpeed);
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollTop + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
  }

  connectedCallback() {
    this.setSlideVisibility();
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      item.setAttribute('aria-hidden', index !== this.currentPage - 1);
      item.tabIndex = index === this.currentPage - 1 ? 0 : -1;
    });
  }
}

customElements.define('vertical-slideshow-component', VerticalSlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);


class ProductRecommendations extends HTMLElement {
  observer = undefined;
  cartUpdateUnsubscriber = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);

    if (this.classList.contains('cart-recommendations')) {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        this.handleCartUpdate(event);
      });
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  handleCartUpdate() {
    fetch(`${routes.cart_url}.js`)
      .then((response) => response.json())
      .then((cart) => {
        if (!cart.items?.length) {
          this.innerHTML = '';
          this.classList.remove('product-recommendations--loaded');
          this.dataset.productId = '';
          return;
        }

        const productId = String(cart.items[cart.items.length - 1].product_id);
        this.dataset.productId = productId;
        this.loadRecommendations(productId);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  initializeRecommendations(productId) {
    this.observer?.disconnect();
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    if (!productId) return;

    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        } else {
          this.innerHTML = '';
          this.classList.remove('product-recommendations--loaded');
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (this.querySelector('.swiper-slide, .grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};
    queue.forEach((queueItem) => {
      items[String(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    this.updateMultipleQty(items);
  }

  getCartQuantityForVariant(items, variantId) {
    if (!Array.isArray(items)) return 0;
    const id = String(variantId);
    return items.reduce((sum, item) => {
      const itemVariantId = String(item.variant_id ?? item.id);
      return itemVariantId === id ? sum + (Number(item.quantity) || 0) : sum;
    }, 0);
  }

  /**
   * Map variant-id quantities to cart/update.js payloads.
   * Automatic discounts can split one variant into several line items with unique keys.
   * Updating by variant id then changes only one line (or adds a new one), so 40 + 200
   * becomes 240 instead of 200. Put the desired qty on the first matching key and zero the rest.
   */
  async resolveCartQuantityUpdates(items) {
    try {
      const cart = await fetch(`${routes.cart_url}.js`).then((response) => response.json());
      const cartItems = Array.isArray(cart.items) ? cart.items : [];
      const updates = {};

      Object.entries(items).forEach(([variantId, quantity]) => {
        const qty = Number(quantity) || 0;
        const matching = cartItems.filter((item) => String(item.variant_id) === String(variantId));

        if (matching.length === 0) {
          updates[String(variantId)] = qty;
          return;
        }

        matching.forEach((line, index) => {
          updates[line.key] = index === 0 ? qty : 0;
        });
      });

      return updates;
    } catch (error) {
      console.error(error);
      return items;
    }
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      metricName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}


class CountdownBar extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
    this.updateTimer = this.updateTimer.bind(this);
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    this.formatNumber = (n) => String(n).padStart(2, '0');
  }

  connectedCallback() {
    this.dataset.complited = this.dataset.complited || 'cycle';
    this.startTimer();
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  disconnectedCallback() {
    this.stopTimer();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  handleVisibilityChange() {
    if (!document.hidden) {
      this.startTimer();
    } else {
      this.stopTimer();
    }
  }

  startTimer() {
    this.stopTimer();
    if (!document.hidden) {
      this.updateTimer();
      this.interval = setInterval(this.updateTimer, 1000);
    }
  }

  stopTimer() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  updateTimer() {
    const now = Date.now();
    let endTime = new Date(this.dataset.date).getTime();
    let timeLeft = Math.max(endTime - now, 0);

    if (timeLeft === 0 && this.dataset.complited === 'cycle') {
      endTime = now + 2.33 * 24 * 60 * 60 * 1000;
      this.dataset.date = new Date(endTime).toISOString();
      timeLeft = endTime - now;
    }

    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    this.setValue('.countdown-bar__days .countdown-bar__number', days);
    this.setValue('.countdown-bar__hours .countdown-bar__number', hours);
    this.setValue('.countdown-bar__min .countdown-bar__number', minutes);
    this.setValue('.countdown-bar__sec .countdown-bar__number', seconds);
  }

  setValue(selector, value) {
    const el = this.querySelector(selector);
    if (el) el.textContent = this.formatNumber(value);
  }
}

customElements.define('countdown-bar', CountdownBar);


class CursorFollower extends HTMLElement {
  constructor() {
    super();
    this.targetX = 0;
    this.targetY = 0;
    this.currentX = 0;
    this.currentY = 0;
    this.ease = 0.1;
    this.animationFrame = null;

    this.hiddenClasses = [
      'button', 'link', 'shopify-payment-button__button', 'header__icon', 'svg-wrapper', 'icon', 'notification-close-popup', 'welcome-close-popup', 'account-icon', 'menu-span', 'facets__range', 'facets__price', 'breadcrumbs__link', 'custom-link', 'quick-add__submit', 'cart-count-bubble', 'button--secondary', 'quantity__input', 'quantity__button', 'product-compare-info', 'pick-up__accordion--icon', 'share-button', 'product__accordion--icon', 'pagination__item', 'swiper-scrollbar', 'swiper-scrollbar-drag', 'field__button', 'full-unstyled-link', 'field__input', 'icon-microphone', 'swatch', 'slider-button', 'swiper-pagination-bullet', 'swiper-pagination', 'pagination-button-text', 'bundles-hotspot-item', 'compare-banner__top-show-btn', 'remove-compare-product', 'navigation-item'
    ];

    this.hiddenTags = [
      'button', 'a', 'input', 'select', 'textarea', 'label', 'form', 'svg', 'summary'
    ];

    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.animateFollower = this.animateFollower.bind(this);
  }

  connectedCallback() {
    if (window.innerWidth < 1025) return;

    this.style.position = 'fixed';
    this.style.top = '0';
    this.style.left = '0';
    this.style.pointerEvents = 'none';
    this.style.zIndex = '10';
    this.style.opacity = '0';
    this.style.willChange = 'transform';

    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseover', this.handleMouseOver);
    document.addEventListener('mouseout', this.handleMouseOut);
    document.addEventListener('mouseenter', this.handleMouseEnter);
    document.addEventListener('mouseleave', this.handleMouseLeave);

    this.animateFollower();
  }

  disconnectedCallback() {
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseover', this.handleMouseOver);
    document.removeEventListener('mouseout', this.handleMouseOut);
    document.removeEventListener('mouseenter', this.handleMouseEnter);
    document.removeEventListener('mouseleave', this.handleMouseLeave);

    cancelAnimationFrame(this.animationFrame);
  }

  handleMouseMove(e) {
    this.targetX = e.clientX - 12;
    this.targetY = e.clientY - 12;
  }

  animateFollower() {
    this.currentX += (this.targetX - this.currentX) * this.ease;
    this.currentY += (this.targetY - this.currentY) * this.ease;
    this.style.transform = `translate(${this.currentX}px, ${this.currentY}px)`;
    this.animationFrame = requestAnimationFrame(this.animateFollower);
  }

  handleMouseOver(e) {
    if (this.checkHover(e.target)) this.style.opacity = '0';
  }

  handleMouseOut(e) {
    if (this.checkHover(e.target)) this.style.opacity = '1';
  }

  handleMouseEnter() {
    this.style.opacity = '1';
  }

  handleMouseLeave() {
    this.style.opacity = '0';
  }

  checkHover(element) {
    // Check current element
    const hasHiddenClass = this.hiddenClasses.some(cls => element.classList.contains(cls));
    const hasHiddenTag = this.hiddenTags.includes(element.tagName.toLowerCase());
    
    if (hasHiddenClass || hasHiddenTag) {
      return true;
    }
    
    // Check parent elements (up to 3 levels)
    let parent = element.parentElement;
    let level = 0;
    while (parent && level < 3) {
      const parentHasHiddenClass = this.hiddenClasses.some(cls => parent.classList.contains(cls));
      const parentHasHiddenTag = this.hiddenTags.includes(parent.tagName.toLowerCase());
      
      if (parentHasHiddenClass || parentHasHiddenTag) {
        return true;
      }
      
      parent = parent.parentElement;
      level++;
    }
    
    return false;
  }
}

customElements.define('cursor-follower', CursorFollower);


class ParallaxSlideshow extends HTMLElement {
  constructor() {
    super();
    this.speed = parseFloat(this.getAttribute('speed')) || 0.2;
    const sliderHeight = this.getAttribute('data-slider-height');
    if (sliderHeight === 'extra-large') {
      this.textSpeed = this.speed / 1.2;
    } else {
      this.textSpeed = this.speed / 1.8;
    }
    
    this.observer     = null;
    this.activeImages = new Set();
    this.initialTops  = new Map();
    this.textEl       = null;
    this.ticking      = false;
    this.onScroll     = this.onScroll.bind(this);
    this.update       = this.update.bind(this);
  }

  connectedCallback() {
    const shouldAnimate = this.getAttribute('data-animate-images') === 'true';
    if (!shouldAnimate) {
      return;
    }

    this.querySelectorAll('.slideshow-image_image').forEach(img => {
      const t = parseFloat(window.getComputedStyle(img).top) || 0;
      this.initialTops.set(img, t);
    });

    const banner = this.closest('.slideshow__slide_images');
    if (banner) {
      this.textEl = banner.querySelector('.banner__content .slideshow__text');
      if (this.textEl) {
        this.textEl.style.willChange = 'transform';
      }
    }

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const imgs = this.querySelectorAll('.slideshow-image_image');
        if (entry.isIntersecting) {
          imgs.forEach(img => this.activeImages.add(img));
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.requestAnimationFrame(this.update);
        } else {
          imgs.forEach(img => {
            this.activeImages.delete(img);
            img.style.transform = '';
          });
          if (this.textEl) {
            this.textEl.style.transform = '';
          }
          if (!this.activeImages.size) {
            window.removeEventListener('scroll', this.onScroll);
          }
        }
      });
    }, { threshold: 0 });

    this.observer.observe(this);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    if (this.observer) this.observer.disconnect();
    this.activeImages.clear();
    this.initialTops.clear();
    if (this.textEl) this.textEl.style.transform = '';
  }

  onScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  update() {
    const banner = this.closest('.slideshow__slide_images');
    if (!banner) return;

    // Document Y of this slide's top (stable while layout doesn't reflow).
    const slideTopDoc = window.scrollY + banner.getBoundingClientRect().top;
    // Scroll past this slide's top — not raw window.scrollY, which breaks mid-page
    // slideshows and pushes text thousands of px off-screen (hidden by overflow).
    const localScroll = window.scrollY - slideTopDoc;

    this.activeImages.forEach((img) => {
      const initTop = this.initialTops.get(img) || 0;
      const factor = 1 + initTop / 1800;
      const yImg = localScroll * this.speed * factor;
      img.style.transform = `translateY(-${yImg}px)`;
    });
    if (this.textEl) {
      const yText = localScroll * this.textSpeed;
      this.textEl.style.transform = `translateY(${yText}px)`;
    }
  }
}

customElements.define('parallax-slideshow', ParallaxSlideshow);


function addEmailInputsValidation() {
    const emailInputs = document.querySelectorAll("input[type='email']");

    if (emailInputs.length === 0) return;

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    emailInputs.forEach(input => {
			
        const form = input.closest("form");
        const submitBtn = form?.querySelector("button[type='submit']");
        const message = form?.querySelector(".form__message");
        const successMessage = form?.querySelector(".form__message--success");
				
        if (!submitBtn) return;

        const validateEmail = () => {
					
            const emailValue = input.value.trim();
            const isValid = emailPattern.test(emailValue);
            
            if (!isValid) {
							if (message) {
                //message.textContent = window.forms.emailError;
                message.innerHTML = `
                  <span class="svg-wrapper">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#CC0303" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M12 16H12.01V16.01H12V16Z" stroke="#CC0303" stroke-width="2.25" stroke-linejoin="round"/>
                      <path d="M12 12V8" stroke="#CC0303" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </span>
                  ${window.forms.emailError}
                `;
							}
							input.classList.add("invalid");
							submitBtn.setAttribute("disabled", "true");
							
							if (emailValue === "") {
								message.textContent = "";
								input.classList.remove("invalid");
								submitBtn.removeAttribute("disabled");
							}
							
							if (successMessage) {
								successMessage.textContent = "";
							}
            } else {
							if (message) {
								message.textContent = "";
							}
							input.classList.remove("invalid");
							submitBtn.removeAttribute("disabled");
            }
        };

        // Validate email when the user changes input (debounced)
        const debouncedValidateEmail = debounce(validateEmail, 300);
        input.addEventListener("input", debouncedValidateEmail);
        input.addEventListener("change", debouncedValidateEmail);

        // Remove message and enable button when user starts typing again
        input.addEventListener("focus", () => {
            const emailValue = input.value.trim();
            const isValid = emailPattern.test(emailValue);

            if (!isValid) {
                // Only set message content if message element exists
                if (message) {
                    message.innerHTML = `
                      <span class="svg-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                          <path d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z" stroke="#CC0303" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12 16H12.01V16.01H12V16Z" stroke="#CC0303" stroke-width="2.25" stroke-linejoin="round"/>
                          <path d="M12 12V8" stroke="#CC0303" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </span>
                      ${window.forms.emailError}
                    `;
                }
                input.classList.add("invalid");
                submitBtn.setAttribute("disabled", "true");
                
                if (emailValue === "") {
                    if (message) {
                        message.textContent = "";
                    }
                    input.classList.remove("invalid");
                    submitBtn.removeAttribute("disabled");
                }
            } else {
                if (message) {
                    message.textContent = "";
                }
                input.classList.remove("invalid");
                submitBtn.removeAttribute("disabled");
            }
        });
    });
}
document.addEventListener('DOMContentLoaded', addEmailInputsValidation);



class LoadMoreButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-load-more-button]');
    this.spinner = this.querySelector('.load-more_spinner');
    this.mode = this.dataset.mode || 'load';
    this.isLoading = false;
    this.abortController = null;
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onIntersect = this.onIntersect.bind(this);

    if (this.mode === 'infinite') {
      if (this.button) this.button.hidden = true;
      this.observer = new IntersectionObserver(this.onIntersect, {
        rootMargin: '300px 0px',
        threshold: 0,
      });
      this.observer.observe(this);
      return;
    }

    if (!this.button || this.button.dataset.loadMoreBound) return;

    this.button.addEventListener('click', this.onButtonClick);
    this.button.dataset.loadMoreBound = 'true';
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    if (this.abortController) {
      this.abortController.abort();
      this.abortController = null;
    }

    if (this.button && this.button.dataset.loadMoreBound) {
      this.button.removeEventListener('click', this.onButtonClick);
      delete this.button.dataset.loadMoreBound;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    this.loadMore();
  }

  onIntersect(entries) {
    if (entries.some((entry) => entry.isIntersecting)) {
      this.loadMore();
    }
  }

  async loadMore() {
    const cardsContainer = document.querySelector(this.getAttribute('target'));
    if (!cardsContainer) return;

    const nextUrl = cardsContainer.dataset.nextUrl;
    if (!nextUrl || this.isLoading) return;

    this.isLoading = true;
    if (this.button) this.button.style.display = 'none';
    if (this.spinner) this.spinner.classList.remove('hidden');

    this.abortController = new AbortController();

    try {
      const response = await fetch(nextUrl, { signal: this.abortController.signal });
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const newCards = html.querySelector('.load_list');
      if (!newCards) return;

      const newItems = newCards.querySelectorAll('.load_item');
      const newUrl = newCards.dataset.nextUrl || '';

      newItems.forEach((item) => cardsContainer.append(item));
      cardsContainer.dataset.nextUrl = newUrl;

      if (!newUrl) {
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
        this.hidden = true;
      } else if (this.mode === 'load' && this.button) {
        this.button.style.display = '';
      }
    } catch (e) {
      if (e.name === 'AbortError') return;
      console.error(e);
      if (this.mode === 'load' && this.button) {
        this.button.style.display = '';
      }
    } finally {
      this.isLoading = false;
      if (this.spinner) this.spinner.classList.add('hidden');
      this.abortController = null;
    }
  }
}

customElements.define('load-more-button', LoadMoreButton);

console.log('Filo 4.0.2');